import React, { useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import { Star, Trash2 } from 'lucide-react';

const API_URL = process.env.REACT_APP_BACKEND_URL;

const DOMAIN_LABELS = {
  constitution: 'Constitution',
  famille: 'Code de la Famille',
  penal: 'Code Penal',
  travail: 'Code du Travail',
  investissement: 'Code des Investissements',
  numerique: 'Code du Numerique',
  procedure_penale: 'Code de Procedure Penale',
  protection_enfant: "Loi sur la Protection de l'Enfant",
  foncier: 'Code Foncier et Immobilier',
  entrepreneuriat: "Loi sur l'Entrepreneuriat et les Startups",
  baux_loyers: 'Baux à Loyers',
  obligations: 'Code des Contrats et Obligations',
};

const getFavorites = () => {
  try {
    return JSON.parse(localStorage.getItem('mibeko_favorites') || '[]');
  } catch { return []; }
};

const removeFavorite = (articleId) => {
  const favs = getFavorites().filter(id => id !== articleId);
  localStorage.setItem('mibeko_favorites', JSON.stringify(favs));
  return favs;
};

const FavoritesPage = () => {
  const [favorites, setFavorites] = useState([]);
  const [articles, setArticles] = useState([]);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    loadFavorites();
  }, []);

  const loadFavorites = async () => {
    const favIds = getFavorites();
    setFavorites(favIds);

    if (favIds.length === 0) {
      setLoading(false);
      return;
    }

    try {
      const fetched = await Promise.all(
        favIds.map(id =>
          fetch(`${API_URL}/api/articles/${id}`)
            .then(r => r.ok ? r.json() : null)
            .catch(() => null)
        )
      );
      setArticles(fetched.filter(Boolean));
    } catch {
      setArticles([]);
    }
    setLoading(false);
  };

  const handleRemove = (articleId) => {
    const newFavs = removeFavorite(articleId);
    setFavorites(newFavs);
    setArticles(prev => prev.filter(a => a.id !== articleId));
  };

  return (
    <div>
      <div style={{ padding: '24px 20px 12px' }}>
        <h1 style={{ fontSize: '24px', fontWeight: 800, color: 'var(--text-dark)', marginBottom: '4px' }}
            data-testid="favorites-title">
          Mes Favoris
        </h1>
        <p style={{ fontSize: '14px', color: 'var(--text-gray)' }}>
          {favorites.length} article{favorites.length !== 1 ? 's' : ''} sauvegarde{favorites.length !== 1 ? 's' : ''}
        </p>
      </div>

      <div className="page-container">
        {loading ? (
          <div className="loading-spinner" />
        ) : articles.length === 0 ? (
          <div className="empty-state" data-testid="empty-favorites">
            <div className="icon-circle lg">
              <Star />
            </div>
            <h2>Aucun favori</h2>
            <p>Sauvegardez vos articles importants pour y acceder rapidement ici.</p>
          </div>
        ) : (
          articles.map(article => (
            <div key={article.id} style={{ display: 'flex', alignItems: 'stretch', gap: '0', marginBottom: '10px' }}>
              <Link
                to={`/article/${article.id}`}
                className="search-result-card"
                style={{ flex: 1 }}
                data-testid={`fav-article-${article.id}`}
              >
                <div className="result-domain">{DOMAIN_LABELS[article.domain] || article.domain}</div>
                <div className="result-number">{article.article_number}</div>
                <div className="result-summary">{article.summary?.substring(0, 100)}...</div>
              </Link>
              <button
                onClick={() => handleRemove(article.id)}
                style={{
                  display: 'flex', alignItems: 'center', justifyContent: 'center',
                  padding: '0 12px', background: 'var(--bg-card)', border: '1px solid var(--border)',
                  borderLeft: 'none', borderRadius: '0 var(--radius-md) var(--radius-md) 0',
                  cursor: 'pointer', color: '#EF4444',
                }}
                data-testid={`remove-fav-${article.id}`}
              >
                <Trash2 style={{ width: '18px', height: '18px' }} />
              </button>
            </div>
          ))
        )}
      </div>
    </div>
  );
};

export default FavoritesPage;
